<template>
  <QuestionBase :id="db.saveField"
                :question="question"
                :errors="[...jsErrors]"
                :valid="!!data.length">
    <div class="accordion sub-items">
      <div class="question-box with-arrow mt-32">
        <transition-group name="fade">
          <ObjectCard v-for="(item, index) in data"
                      :key="'giftAmendment-' + item.id"
                      :id="'giftAmendment' + index"
                      :ref="'giftAmendment' + index"
                      :value="item"
                      :index="index"
                      :title="itemTitle(item)"
                      type="giftAmendment"
                      :loading="false"
                      :show-save="true"
                      :show-confirm="true"
                      @delete="deleteItem(item.id)"
                      @save="saveItem(index)">
            <b-form-textarea v-model="item.description"
                          placeholder="Please provide details..."
                          class="mt-2"/>
          </ObjectCard>
        </transition-group>

        <!-- New item form -->
        <ObjectCard v-if="form" class="mt-4"
                    ref="gift-add"
                    :value="form"
                    :title="typeLabel(form.type)"
                    type="giftAmendment-add"
                    :loading="false"
                    :show-save="false"
                    :show-confirm="true"
                    @delete="form = null"
                    @save="confirmAdd">
          <b-form-textarea v-model="form.description"
                          placeholder="Please provide details..."
                          class="mt-2"/>
        </ObjectCard>

        <b-button-group v-if="!form" class="w-100 mt-4">
          <b-button class="btn-question mr-1" @click="add('add')">
            <i class="i-Add text-25 font-weight-800 mr-2"></i> Add
          </b-button>
          <b-button class="btn-question mr-1" @click="add('remove')">
            <i class="i-Close text-25 font-weight-800 mr-2"></i> Remove
          </b-button>
          <b-button class="btn-question" @click="add('edit')">
            <i class="i-Pen-2 text-25 font-weight-800 mr-2"></i> Edit Details
          </b-button>
        </b-button-group>
      </div>
    </div>
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import {objectSaveHelpers} from "@/components/common/questionnaires/question/questions/objects/objectSaveHelpers";
import { saveHelpers } from "@/views/questionnaires/saveHelpers";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import ObjectCard from "@/components/common/questionnaires/question/questions/objects/ObjectCard";

export default {
  name: 'Gifts',
  mixins: [questionLoadHelpers, saveHelpers, objectSaveHelpers],
  components: {
    ObjectCard,
    QuestionBase
  },
  props: {
    value: {
      type: Array,
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value || []
      }
    }
  },
  data() {
    return {
      question: {
        title: 'What specific gifts would you like to add, edit, or remove?',
        subTitle: 'Provide the details of the changes you want to make to your gifts. If you are adding a new gift, describe the item or state the exact monetary amount, and tell us the full name of the person or charity who should receive it. If you are editing or removing a gift, simply identify the existing gift and let us know what needs to be changed or taken out of your Will.',
        tip: null
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'gifts',
        formPath: 'gifts',
        jsonSaveField: 'gifts'
      },
      args: {
        skippable: false,
        required: true,
        customErrorMessage: 'Please add at least one change before continuing',
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
      form: null,
    }
  },
  methods: {
    typeLabel(type) {
      const labels = {
        add: 'Add Gift',
        remove: 'Remove Gift',
        edit: 'Edit Gift Details'
      }
      return labels[type] || type
    },
    itemTitle(item) {
      const prefix = this.typeLabel(item.type)
      return item.description ? `${prefix}: ${item.description}` : prefix
    },
    add(type) {
      this.form = { type, description: '' }
    },
    confirmAdd() {
      if (!this.form) return
      const newItem = {
        id: Date.now(),
        type: this.form.type,
        description: this.form.description
      }
      this.$emit('input', [...this.data, newItem])
      this.form = null
      this.$nextTick(() => { this.save() })
    },
    deleteItem(id) {
      this.$emit('input', this.data.filter(item => item.id !== id))
      this.$nextTick(() => { this.save() })
    },
    saveItem(index) {
      this.$emit('input', [...this.data])
      this.$nextTick(() => {
        this.save()
        const card = this.$refs['giftAmendment' + index]
        if (card) card.showData = false
        this.closeCard ('giftAmendment' + index)
      })
    }
  }
}
</script>
